import dictionaryService from '@/core/dictionary/dictionary.service';

export default {
    install: (app, options) => {
        app.config.globalProperties.$dictionary = dictionaryService;
    },
};
